import users from 'modules/core/store/collections/users'
import type User from 'modules/core/store/models/User'

import type Dashboard from 'modules/reports/store/models/Dashboard'

/**
 * Gets the author user for a dashboard from the users collection.
 * This helper function avoids importing the users collection into the Dashboard model.
 */
export const getDashboardAuthor = (dashboard: Dashboard): User | null | undefined => {
  return users.find({
    id: dashboard.attributes.author_id,
  })
}
